import { useQuery } from "@tanstack/react-query";
import { getCurrentTenantContract } from "../../api/tenants";

function useGetCurrentTenant({ propertyUid }: { propertyUid: string }) {
  const query = useQuery({
    queryKey: ["current-tenant", propertyUid],
    queryFn: () => getCurrentTenantContract({ propertyUid }),
    retry: false,
    enabled: !!propertyUid,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
  return { ...query, data: query.data?.data };
}

export default useGetCurrentTenant;
